/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unknown-property */

import React, { Component } from 'react'
// eslint-disable-next-line no-unused-vars
import ReactPlayer from 'react-player' 
import Iframe from 'react-iframe'
import { Link } from 'react-router-dom';


export default function Aboutusection() {
  return (
  <> 
  <br></br><br></br>

  <section>
  <div className="mx-auto max-w-screen-xl px-4 py-2  lg:px-3 lg:py-3 lg:mb-3">
    <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-16">
      <div className="relative h-64 overflow-hidden rounded-lg sm:h-8 lg:order-last lg:h-full">
     
      <div className='mr-2 player-wrapper'>
      <Iframe url="https://ik.imagekit.io/sitekitpro/Video/Sitekitpro%20_%20Create%20Website%20Quickly%20In%20Less%20then%201%20Day%20%20_%20Get%20Ready%20Made%20Templates%20Design..mp4"
         width="100%"
         height="280px" 
         display="block"
         position="relative" scrolling="no" overflow-y="hidden" /> 
        </div>

      </div>

      <div className="ml-6 mt-6 ">
        <h2 className="text-[18px] font-bold sm:text-4xl"> About <a className="text-orange-700" > Sitkitpro  </a> </h2>

        <p className="mt-4 text-gray-600">
        Now Get Premium Themes, Plugins, Sitekit, Elementor Themes.  SiteKit offers themes, plugins, sitekits, and other high-quality resources. Sitekit Pro allows you to create a complete premium website in a single day with an installation process that takes only an hour and at a cost that is reasonable.
        </p>
     
<Link to="/contact" class="mt-4 inline-flex items-center gap-2 rounded border-2 border-indigo-600 bg-orange-500 px-8 py-3 text-white hover:bg-white  hover:text-orange-500 focus:outline-none focus:ring active:text-indigo-500"
  href="/Contact"
>
  <span class="text-sm font-medium"> 
Contact Us
      </span>

  <svg
    class="h-5 w-5 rtl:rotate-180"
    xmlns="./assets/banners/1.webp"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
   <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
  </svg>
</Link>
 
      </div>
    </div> 
  </div>

<br></br><br></br>
  
 {/* <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-20">
      <div className="grid gap-10 lg:grid-cols-2">
      <div>
          <img
            className="object-cover w-full h-56 rounded shadow-lg sm:h-96"
            src="./assets/banners/mm.webp"
            alt=""
          />
        </div>
        <div className="lg:pr-10">
          <a
            href="/"
            aria-label="Go Home"
            title="Logo"
            className="inline-block mb-5"
          >
            <div className="flex items-center justify-center w-12 h-12 rounded-full bg-indigo-50">
            <i style={{fontSize:40}} class="fa-solid fa-bullseye"></i>
            </div>
          </a>
          <h5 className="mb-4 text-4xl font-extrabold leading-none">
          Our Mission
 
          </h5>
          <p className="mb-6 text-gray-900">
          Our Mission is to Serve our client’s such a manner so that they can have successful unicorn companies from us in the best manners.

We have the vision to expand our solutions to the international level and all
around the globe. And try to innovate new technology at a greater pace so that can provide services to our clients in the best way we can.
          </p>
          <hr className="mb-5 border-gray-300" />
          
        </div>
       
      </div>
    </div>


*/}

  
</section>
  </>
  )
}

 